/* eslint-disable @typescript-eslint/no-useless-constructor */
import { SupabaseClient } from '@supabase/supabase-js';
import { BaseRepository } from '../BaseRepository';

/**
 * Storage repository that handles all storage-related operations
 */
export class StorageRepository extends BaseRepository {
  constructor(supabase: SupabaseClient<any, 'public', any>) {
    super(supabase);
  }

  /**
   * Upload a file to a storage bucket
   */
  async uploadFile(file: File, bucket: string): Promise<any> {
    if (!file || !bucket) return;
    return await this.supabase.storage.from(bucket).upload(file.name, file);
  }

  /**
   * Download a file from a storage bucket
   */
  async downloadFile(
    filename: string,
    bucket: string,
  ): Promise<{ data: Blob | null; error: any }> {
    if (!filename || !bucket)
      return { data: null, error: 'Missing filename or bucket' };
    return await this.supabase.storage.from(bucket).download(filename);
  }
}
